module.exports = __webpack_public_path__ + "static/media/token10.15b31208.png";